import request from "@/utils/request";
import Cookies from "js-cookie";
// 获取用户身份 登录时用
export function getloginIdentity(data) {
  return request({
    url: `/base/login/hero/v1/last/identity/list?username=${data}`,
    method: "get",
  });
}
// 获取用户身份列表 登录后使用 切换身份
export function getUserIdentity() {
  return request({
    url: `/base/login/v1/identity/list`,
    method: "get",
  });
}
// 切换身份
export function switchIdentity(data) {
  return request({
    url: `/base/login/v1/switch/identity?identityId=${data}`,
    method: "get",
  });
}
// 登录
export function loginDo(data) {
  return request({
    url: "/base/login/v1/do",
    method: "post",
    data: data,
  });
}

// 获取学校列表
export function getSchoolList(domainName) {
  return request({
    url: `/base/system/tenant/school/hero/get/school/list?domainName=${domainName}`,
    method: "get",
  });
}

// 手机号登录验证码
export function sendSmsCode(phone) {
  return request({
    url: `/base/login/v1/send/sms/code?phone=${phone}`,
    method: "get",
  });
}
// 根据域名获取学校id
export function getTenantIdDomain(domainName) {
  return request({
    url: `/base/system/tenant/school/hero/get/tenant/id/by/domain?domainName=${domainName}`,
    method: "get",
  });
}
// 注册(t)
// export function register(data) {
//   return request({
//     url: "/base/user/v1/register",
//     method: "post",
//     data: data,
//   });
// }
export function register(data) {
  return request({
    url: "/base/system/user/hero/user/phone/register",
    method: "post",
    data: data,
  });
}

// 登出
export function logout() {
  return request({
    url: "/base/login/v1/logout",
    method: "get",
  });
}

// 创建微信登录二维码
export function qrcodeLogin(type = 1, projectId = "") {
  return request({
    url: "/base/wechat/hero/create/wechat/qrcode",
    method: "post",
    data: { type: type, domainName: location.host, projectId: projectId }, //二维码类型：1微信登录
  });
}

// 获取微信登录二维码信息
export function qrcodeInfo(qrCodeId) {
  return request({
    url: `/base/wechat/hero/get/wechat/qrcode/info?qrCodeId=${qrCodeId}`,
    method: "get",
  });
}

// 更新二维码信息
export function updateQRCode(data) {
  return request({
    url: "/base/wechat/hero/update/wechat/qrcode",
    method: "post",
    data: data,
  });
}

// 获取当前用户绑定的学校列表(去token)
export function currentUser(userId, domainName) {
  return request({
    url: `/base/system/school/user/hero/get/school/list/current/user?userId=${userId}&domainName=${domainName}`,
    method: "get",
  });
}

// 获取前台菜单
export function getMenulist(userId) {
  return request({
    url: `/app/ddxk/role/v1/getHomeMenuByUserId?userId=${userId}`,
    method: "get",
  });
}

// 登录日志
export function doLoginLog(logId, pfId) {
  return request({
    url: `/base/login/v1/doLoginLog?logId=${logId}&pfId=${pfId}`,
    method: "get",
    headers: {
      Authorization: Cookies.get("tokenValue"),
      "tenant-id": Cookies.get("schoolId"),
    },
  });
}

export function getIdentityInfo(data, token, school) {
  return request({
    url: `/base/login/hero/v1/last/identity/list?username=${data}`,
    method: "get",
    headers: {
      Authorization: token,
      "tenant-id": school,
    },
  });
}
